"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LTILaunch = void 0;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var iframe_1 = require("../iframe/iframe");
function LTILaunch(_a) {
    var url = _a.url, sx = _a.sx, _b = _a["aria-label"], ariaLabel = _b === void 0 ? 'lti launch' : _b;
    // some style
    var someStyle = __assign({ position: 'fixed', width: '100%', height: '100%' }, sx);
    var wrapperAttributes = {
        sx: someStyle,
        'aria-label': ariaLabel,
        'data-testid': 'lti-launch',
    };
    // set allowed origins
    var p = url.split('/'); // p for url parts
    var domain = url ? p[0] + '//' + p[2] : '';
    // post message listener for data from the iframe
    window.addEventListener('message', onMessage, false);
    /**
     * onMessage
     * @param this - the current window
     * @param event - the post message event
     * @returns void
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function onMessage(event) {
        // only allow certain origins
        if (domain !== event.origin)
            return;
        window.localStorage.setItem('jwt', event.data.ltiContext);
    }
    /**
     * onLoad
     * @param event - the iframe onload dom event
     * @param iframeRef - iframe dom reference
     * @returns void
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function onLoad(event, iframeRef) {
        // TODO: implement player launch here
    }
    return (react_1.default.createElement(material_1.Box, __assign({}, wrapperAttributes),
        react_1.default.createElement(iframe_1.Iframe, { url: url, onLoad: onLoad })));
}
exports.LTILaunch = LTILaunch;
